export default class Slider {
  get DEFAULT_OPTIONS() {
    return {
      wrapperClass: 'slides',
      slideClass: 'slide',
      slideActiveClass: 'is-selected',
      slidesPerView: 1,
      loop: false,
      speed: 600,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: '.reason-slider-paginations',
        bulletActiveClass: 'is-selected',
        clickable: true,
      },
      autoplay: {
        disableOnInteraction: false
      }
    }
  }

  constructor() {
    this.target = document.querySelector('[data-reason-slider]');
    if (!this.target) return;
    this.slide = [...this.target.querySelectorAll('.slide')];
    this.balloon = [...document.querySelectorAll('[data-reason-slide-balloon]')];
    this.prev = this.target.querySelector('[data-reason-slider-prev]')
    this.next = this.target.querySelector('[data-reason-slider-next]')
    this.speed = 600
    this.slider;
    this.observer;
    this.init();
  }

  init() {
    this.setup();
    this.create();
    this.onScroll();
    this.animateBalloon();
    this.onPrevClick();
    this.onNextClick();
  }

  setup() {
    gsap.set(this.balloon, { autoAlpha: 0 });
  }

  create() {
    this.slider = new Swiper(this.target, {
      ...this.DEFAULT_OPTIONS,
      on: {
        slideChangeTransitionStart: () => {
          this.animateBalloon();
        },
      },
    });
    this.slider.autoplay.stop()
  }

  onScroll() {
    this.observer = new IntersectionObserver (entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio === 1) {
          this.slider.autoplay.start()
        } else if (entry.intersectionRatio === 0) {
          this.slider.slideToLoop(0)
          this.slider.autoplay.stop()
        }
      });
    },
    { threshold: [0, 1.0] });
    this.observer.observe(this.target)
  }

  animateBalloon() {
    this.setup();
    this.slide.forEach(slide => {
      if (slide.classList.contains('is-selected')) {
        const balloons = [...slide.querySelectorAll('[data-reason-slide-balloon]')];
        setTimeout(() => {
          gsap.fromTo(balloons, {
            autoAlpha: 0,
            yPercent: index => balloons[index].dataset.reasonSlideBalloonY,
          }, {
            autoAlpha: 1,
            yPercent: 0,
            duration: 0.4,
            ease: 'power2.out',
            stagger: 0.2,
          })
        }, 450);
      }
    });
  }

  onPrevClick() {
    const totalSlidesLen = this.slider.slides.length;
    this.prev.addEventListener('click', () => {
      if (this.slider.isBeginning) {
        this.slider.slideTo(totalSlidesLen - 1, this.speed);
      } else {
        this.slider.slideTo(this.slider.realIndex - 1, this.speed);
      }
    });
  }

  onNextClick() {
    this.next.addEventListener('click', () => {
      if (this.slider.isEnd) {
        this.slider.slideTo(0, this.speed);
      } else {
        this.slider.slideTo(this.slider.realIndex + 1, this.speed);
      }
    });
  }
}